import { render, staticRenderFns } from "./qrCodePayment.vue?vue&type=template&id=0bbaa729&scoped=true"
import script from "./qrCodePayment.vue?vue&type=script&lang=js"
export * from "./qrCodePayment.vue?vue&type=script&lang=js"
import style0 from "./qrCodePayment.vue?vue&type=style&index=0&id=0bbaa729&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbaa729",
  null
  
)

export default component.exports